import { render, staticRenderFns } from "./FiscalPayment.vue?vue&type=template&id=70ad3619&scoped=true&"
import script from "./FiscalPayment.vue?vue&type=script&lang=js&"
export * from "./FiscalPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad3619",
  null
  
)

export default component.exports